import { AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Text, VStack } from "@chakra-ui/react";
import { HeaderLink } from "../../../HeaderLink";
import type { HeaderLinksGroup } from "../../../types";
import { buildTestId } from "../../../Header.utils";

export const HeaderLinkGroup = ({
  headerLinksGroupItems,
  headerLinksGroupMainGroupLinkName,
}: Pick<HeaderLinksGroup, "headerLinksGroupItems" | "headerLinksGroupMainGroupLinkName">) => (
  <AccordionItem border="none" bg="transparent">
    <AccordionButton
      py={0}
      pl={0}
      fontSize="lg"
      borderRadius="sm"
      data-testid={`${buildTestId(headerLinksGroupMainGroupLinkName)}-button-mobile`}
    >
      {headerLinksGroupMainGroupLinkName && (
        <Text flex="1" textAlign="left">
          {headerLinksGroupMainGroupLinkName}
        </Text>
      )}
      <AccordionIcon boxSize={6} sx={{ color: "primary.900" }} />
    </AccordionButton>
    <AccordionPanel p={0} m={0} mb={1} fontSize="md" px={6}>
      <VStack
        spacing={4}
        align="left"
        pt={5}
        color="greyscale.600"
        data-testid={`${buildTestId(headerLinksGroupMainGroupLinkName)}-items-mobile`}
      >
        {headerLinksGroupItems.map(
          ({ _uid, headerLink, headerLinkHideLinkForLanguages, headerLinkName, headerLinkTrackingEvent }) => (
            <HeaderLink
              key={_uid}
              headerLinkName={headerLinkName}
              headerLink={headerLink}
              headerLinkHideLinkForLanguages={headerLinkHideLinkForLanguages}
              headerLinkTrackingEvent={headerLinkTrackingEvent}
            />
          )
        )}
      </VStack>
    </AccordionPanel>
  </AccordionItem>
);
